import script from "./OrderItemTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderItemTable.vue?vue&type=script&lang=ts&setup=true"

import "./OrderItemTable.vue?vue&type=style&index=0&id=134913ad&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-134913ad"]])

export default __exports__